/**
 * How a collection run finds its candidate contracts.
 *
 * Mirrors the backend enum {@code com.mvs.backend.pd.enums.PdCollectionMode} (persisted via
 * {@code @Enumerated(EnumType.ORDINAL)}; the value travels as the ordinal). Member names and order MUST match
 * the backend declaration exactly — append only, never insert, reorder or rename.
 */
export enum PdCollectionModeEnum {
    DELTA,
    FULL,
}
